import type { CookieOptions } from '@supabase/ssr';

function normalizeHostname(input: string) {
  return input.trim().toLowerCase().replace(/:\d+$/, '');
}

function getCookieDomainForHostname(hostname?: string | null) {
  if (!hostname) return undefined;

  const normalized = normalizeHostname(hostname);
  if (normalized === 'drakos.io' || normalized.endsWith('.drakos.io')) {
    return '.drakos.io';
  }

  return undefined;
}

function getDefaultCookieDomain(hostname?: string | null) {
  const configuredDomain = process.env.SUPABASE_COOKIE_DOMAIN?.trim();
  if (configuredDomain) return configuredDomain;

  const hostDomain = getCookieDomainForHostname(hostname);
  if (hostDomain) return hostDomain;

  const appUrl = process.env.NEXT_PUBLIC_APP_URL?.trim();
  if (!appUrl) return undefined;

  try {
    return getCookieDomainForHostname(new URL(appUrl).hostname);
  } catch {
    return undefined;
  }
}

export function getSupabaseCookieOptions(hostname?: string | null): CookieOptions {
  return {
    domain: getDefaultCookieDomain(hostname),
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'lax',
    path: '/',
    maxAge: 60 * 60 * 24 * 30,
    httpOnly: false,
  };
}
